document.addEventListener('mouseup', (e) => {
  if (e.target.closest('.reviewLink')) {
    const container = document.querySelector('.ptContainer');
    if (container) {
      const containerBottom = container.getBoundingClientRect().bottom + window.scrollY;

      window.scrollTo({
        top: containerBottom - (5 * parseFloat(getComputedStyle(document.documentElement).fontSize)),
        behavior: 'smooth'
      });
    }
  }
});
